<template>
  <div id="exhibitionItem">
    <div class="title"><span>展陈业务</span></div>
    <!-- <el-carousel indicator-position="outside" id="myCarousel">
      <el-carousel-item v-for="(item, index) in list" :key="index">
        <div class="img-box">
          <div class="left-img">
            <div class="img-text">
              <img :src="item[0].thumbnail_path" />
              <p>{{ item[0].title }}</p>
            </div>
          </div>
          <div class="right-img">
            <div class="img-text">
              <img :src="item[1].thumbnail_path" width="100%" />
              <p>{{ item[1].title }}</p>
            </div>
            <div class="img-text">
              <img :src="item[2].thumbnail_path" width="100%" />
              <p>{{ item[2].title }}</p>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel> -->
    <div class="panel">
      <div class="panel_left">
        <h5>政府类展台</h5>
        <div
          class="panel_view"
          @click="
            openPdf(
              'http://m.zhongshe.cc/pdf/%E4%B8%AD%E8%AE%BE%E9%9B%86%E5%9B%A2%E5%AE%98%E7%BD%91/%E5%B1%95%E9%99%88%E9%83%A8%E5%AE%A3%E4%BC%A0%E6%89%8B%E5%86%8C.pdf'
            )
          "
        >
          <span>查看详情</span>
          <img src="../../assets/images/arrow.png" />
        </div>
      </div>
      <img class="right_img" src="../../assets/images/img_1.png" />
    </div>
    <div class="panel">
      <div class="panel_left">
        <h5>企业类展台</h5>
        <div
          class="panel_view"
          @click="
            openPdf(
              'http://m.zhongshe.cc/pdf/%E4%B8%AD%E8%AE%BE%E9%9B%86%E5%9B%A2%E5%AE%98%E7%BD%91/%E5%B1%95%E9%99%88%E9%83%A8%E5%AE%A3%E4%BC%A0%E6%89%8B%E5%86%8C.pdf'
            )
          "
        >
          <span>查看详情</span>
          <img src="../../assets/images/arrow.png" />
        </div>
      </div>
      <img class="right_img" src="../../assets/images/img_2.png" />
    </div>
  </div>
</template>
<script>
// import * as api from "../../core/api";
export default {
  data() {
    return {
      list: [],
    };
  },
  methods: {
    // 是否安卓
    isAndroid() {
      const u = navigator.userAgent;
      const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
      return isAndroid;
    },
    openPdf(url) {
      // if (!this.isAndroid()) {
      //   window.open(url, "_blank");
      //   return;
      // }
      this.$router.push({ path: "/pdf", query: { url } });
    },
  },
  // async created() {
  //   const res = await api.get("/api/services");
  //   if (res.data) {
  //     const len = Math.ceil(res.data.length / 3);
  //     for (let i = 0; i < len; i++) {
  //       const list = res.data.splice(0, 3);
  //       this.list.push(list);
  //     }
  //   }
  // },
  // mounted() {
  //   const myCarousel = document.getElementById("myCarousel");
  //   myCarousel.addEventListener("touchstart", (e) => {
  //     this.thetouchstart(e);
  //   });

  //   myCarousel.addEventListener("touchend", (e) => {
  //     this.thetouchend(e);
  //   });
  // },
  // methods: {
  //   thetouchstart(e) {
  //     this.theTouch = e.touches[0].pageX; //保存开始滑动的点
  //   },
  //   thetouchend(e) {
  //     if (e.changedTouches[0].pageX > this.theTouch) {
  //       //判断手指是向左还是向右滑动
  //       this.$refs.myCarousel.prev();
  //     } else {
  //       this.$refs.myCarousel.next();
  //     }
  //   },
  // },
};
</script>

<style lang="scss" scoped>
#exhibitionItem {
  padding: 16px;
  margin-top: 22px;
  background: #f6f9ff;
  .panel {
    width: 343px;
    height: 110px;
    background: #ffffff;
    border-radius: 5px 5px 5px 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    .panel_left {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      font-weight: 400;
      font-size: 14px;
      color: #0068b7;
      h5 {
        font-size: 18px;
        color: #2b4360;
        margin-bottom: 16px;
      }
    }
    .panel_view {
      display: flex;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
      }
    }
    .right_img {
      width: 174px;
    }
  }
  .title {
    display: flex;
    align-items: center;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 18px;
    color: #0068b7;
    position: relative;
    margin-bottom: 50px;
    span {
      position: absolute;
      z-index: 2;
    }
  }
  .title::after {
    content: "DISPLAY";
    position: absolute;
    font-weight: bold;
    font-size: 18px;
    color: #efefef;
    top: 1px;
    z-index: 1;
  }
  .title::before {
    content: "";
    width: 86px;
    height: 3px;
    background: #0068b7;
    position: absolute;
    top: 24px;
  }

  // /deep/.el-carousel__container {
  //   height: 195px;
  // }
  // @media only screen and (min-width: 400px) {
  //   /deep/.el-carousel__container {
  //     height: 240px;
  //   }
  // }

  // @media only screen and (min-width: 460px) {
  //   /deep/.el-carousel__container {
  //     height: 280px;
  //   }
  // }

  // @media only screen and (min-width: 520px) {
  //   /deep/.el-carousel__container {
  //     height: 310px;
  //   }
  // }

  // @media only screen and (min-width: 580px) {
  //   /deep/.el-carousel__container {
  //     height: 360px;
  //   }
  // }
  // @media only screen and (min-width: 660px) {
  //   /deep/.el-carousel__container {
  //     height: 420px;
  //   }
  // }

  // @media only screen and (min-width: 780px) {
  //   /deep/.el-carousel__container {
  //     height: 480px;
  //   }
  // }

  // @media only screen and (min-width: 860px) {
  //   /deep/.el-carousel__container {
  //     height: 560px;
  //   }
  // }

  // @media only screen and (min-width: 1000px) {
  //   .left-img {
  //     img {
  //       max-height: 560px;
  //     }
  //   }
  //   .right-img {
  //     img {
  //       max-height: 280px;
  //     }
  //   }
  // }

  // /deep/.el-carousel {
  //   margin-top: 10px;
  // }
  // .img-box {
  //   height: 100%;
  //   display: flex;
  //   justify-content: center;
  //   .left-img {
  //     margin-right: 5px;
  //     img {
  //       width: 100%;
  //     }
  //   }
  //   .right-img {
  //     display: flex;
  //     flex-direction: column;
  //   }
  //   .img-text {
  //     position: relative;
  //     p {
  //       position: absolute;
  //       bottom: 10px;
  //       left: 10px;
  //       color: #fff;
  //       font-size: 14px;
  //       font-weight: 600;
  //     }
  //   }
  // }
}
</style>